import React from 'react';

function RecallsSkeleton({ count = 5 }) {
    return (
        <div className="recall-skeleton">
            {Array.from({ length: count }, (_, index) => (
                <div key={index} className="recall-skeleton__row">
                    <div className="recall-skeleton__content">
                        <div className="recall-skeleton__line recall-skeleton__line--title" />
                        <div className="recall-skeleton__line recall-skeleton__line--meta" />
                    </div>
                    <div className="recall-skeleton__badge" />
                </div>
            ))}
        </div>
    );
}

export default RecallsSkeleton;
